<template>
  <div :class="['form-control w-full', layout]">
    <label :class="['label', labelLayout]" :style="{ width: labelWidth }" v-if="label" :for="name">
      <span class="label-text">{{ label }}<span v-if="required" class="text-red-500">*</span>: </span>
    </label>
    <div v-if="disabled" :class="inputLayout">
      <my-input :class="[modelValue && modelValue.color ? `text-${modelValue.color}` : '']" :modelValue="modelValue ? modelValue[labelKey || 'name'] : ''" disabled readonly></my-input>
    </div>
    <select v-else v-model="value1" :class="[
      'select select-bordered font-normal',
      inputLayout, {
        'select-error': error
      },
    ]" :readonly="readonly">
      <option v-if="nullable" :value="null">{{ placeholder }}</option>
      <option v-for="option in options" :key="option.id" :value="option.id" :selected="value1 && value1.id === option.id">{{ option[labelKey || 'name'] }} </option>
    </select>
  </div>
</template>
<script>
export default {
  props: {
    label: { type: String },
    modelValue: { type: Object, default: () => { return null } },
    options: { type: Array, default: () => { return [] } },
    readonly: { type: Boolean },
    disabled: { type: Boolean },
    name: { type: String },
    labelKey: { type: String },
    error: { type: Boolean, default: false },
    placeholder: { type: String, default: 'сонгох..' },
    nullable: { type: Boolean, default: true },
    required: { type: Boolean, default: false }
  },
  inject: {
    labelPosition: { type: String, default: 'top' },
    labelWidth: { type: String, default: 'auto' }
  },
  computed: {
    layout () {
      if (this.labelPosition === 'left') {
        return 'flex flex-row space-x-2'
      } else {
        return ''
      }
    },
    labelLayout () {
      if (this.labelPosition === 'left') {
        return 'p-0 flex justify-end items-center text-right'
      } else {
        return ''
      }
    },
    inputLayout () {
      if (this.labelPosition === 'left') {
        return 'flex-1'
      } else {
        return 'w-full'
      }
    },
    value1: {
      get () {
        return this.modelValue ? this.modelValue.id : null
      },
      set (val) {
        const item = this.options.find(c => c.id === val)
        this.$emit('update:modelValue', item)
      }
    }
  },
  methods: {
  }
}
</script>
